var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductreport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.40002 119.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#010101;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0641\u0631\u0648\u0634 \u0645\u062D\u0635\u0648\u0644") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.87,72.27V28.54a1.84151,1.84151,0,0,0-1.84-1.84H14.1A3.10479,3.10479,0,0,0,11,29.81V94.16a10.81025,10.81025,0,0,0,10.81,10.81H65.24a24.0656,24.0656,0,1,0,28.63-32.7ZM31.96,40.86a5.03,5.03,0,1,1,5.03-5.03A5.02744,5.02744,0,0,1,31.96,40.86Zm32.68-5.03a5.03,5.03,0,1,1,5.03,5.03A5.03383,5.03383,0,0,1,64.64,35.83Zm22.69,79.42a19.82007,19.82007,0,1,1,19.82-19.82A19.85089,19.85089,0,0,1,87.33,115.25Z",
    transform: "translate(-11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.89,100.38a9.6723,9.6723,0,0,1-1.04,1.26Z",
    transform: "translate(-11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.52,23.02H65.06a14.39874,14.39874,0,0,0-28.79,0h-9.6a23.94281,23.94281,0,0,1,47.85,0Z",
    transform: "translate(-11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.85,101.64a9.6723,9.6723,0,0,0,1.04-1.26Z",
    transform: "translate(-11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.14,89.25l-9.22,11.09-.03.04-1.04,1.26-.09.09-5.96,7.18a1.63205,1.63205,0,0,1-2.51.04l-3.65-3.98-5.79-6.32a2.08475,2.08475,0,0,1,0-2.8l1.49-1.57a1.63077,1.63077,0,0,1,2.45.07l5.18,5.79a1.63534,1.63534,0,0,0,2.55-.05l9.35-11.64L96.8,84.8a1.63246,1.63246,0,0,1,2.51-.09l1.72,1.8A2.10921,2.10921,0,0,1,101.14,89.25Z",
    transform: "translate(-11)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductreport);
export default __webpack_public_path__ + "static/media/Productreport.21d0107b9de13aaaf5b2c11aa14ed0c3.svg";
export { ForwardRef as ReactComponent };